// src/context/TenantContext.jsx
import React, { createContext, useContext, useEffect, useState } from "react";
import { supabase } from "services/supabaseClient";

const TenantContext = createContext(null);

export function TenantProvider({ children }) {
  const [tenant, setTenant] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    async function fetchTenant() {
      setLoading(true);

      try {
        const hostname = window.location.hostname;

        const { data, error } = await supabase.rpc("resolve_tenant", {
          p_hostname: hostname,
          p_fallback_slug: "grm",
        });

        if (error) {
          console.error("[TenantProvider] resolve_tenant error:", error);
          if (!cancelled) setTenant(null);
          return;
        }

        const resolved = Array.isArray(data) ? data[0] ?? null : data ?? null;

        if (!resolved?.id) {
          console.error("[TenantProvider] Tenant resolution failed.", {
            hostname,
          });
          if (!cancelled) setTenant(null);
          return;
        }

        const tenantConfig = {
          ...resolved,
          enabledApps: [],
        };

        if (
          tenantConfig.theme &&
          typeof tenantConfig.theme === "object" &&
          !Array.isArray(tenantConfig.theme)
        ) {
          Object.entries(tenantConfig.theme).forEach(([key, value]) => {
            document.documentElement.style.setProperty(
              `--tenant-${key}`,
              String(value)
            );
          });
        }

        if (!cancelled) setTenant(tenantConfig);
      } catch (err) {
        console.error("[TenantProvider] Tenant fetch failed:", err);
        if (!cancelled) setTenant(null);
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    fetchTenant();

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <TenantContext.Provider value={{ tenant, loading }}>
      {children}
    </TenantContext.Provider>
  );
}

export function useTenant() {
  return useContext(TenantContext);
}